import { render } from "./LeaveEntitlementReport.vue?vue&type=template&id=5d245079&scoped=true"
import script from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=5d245079&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d245079"]])

export default __exports__